module.exports = __webpack_public_path__ + "static/media/chevron-right-transparent.a28420db.svg";